import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { InviteGuestFormFields } from "./_components/invite-guest-form-fields";

export function InviteGuestView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:InviteGuest");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <InviteGuestFormFields />
    </CenteredLayout>
  );
}
